import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { S1PositionsCard } from "./card";
import { S1PositionsNew } from "./new";
import { S1PositionsTable } from "./table";

export default function S1Positions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | S1 Positions");
  }, []);

  return (
    <Routes>
      <Route index element={<S1PositionsTable />} />
      <Route path="new" element={<S1PositionsNew />} />
      <Route path=":id" element={<S1PositionsCard />} />
    </Routes>
  );
}
